import { useCreateQuery } from '../../CRUD';
import { axiosService } from '../../services/axiosService';
import { TCustomForm, TFetchCustomFormsParameters } from './types';

const useFetchCustomForm = (params: TFetchCustomFormsParameters) => {
  async function queryFn() {
    const { data } = await axiosService.post<TCustomForm>(
      '/v2/patientForms',
      params,
    );

    return data;
  }

  // prevent multiple calls no matter what happens
  const options = {
    enabled: false,
    staleTime: Infinity,
    refetchInterval: Infinity,
    retry: false,
  };

  return useCreateQuery(['fetchCustomForm', params], queryFn, params, options);
};

export default useFetchCustomForm;
